import { motion } from "framer-motion";

import { NavLink } from "react-router-dom";
import { menuItemVariants } from "../variants";

const MenuItem = ({ title, to }) => {
  return (
    <motion.li variants={menuItemVariants}>
      <NavLink
        className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
        key={title}
        end
        to={to}
      >
        {title}
      </NavLink>
    </motion.li>
  );
};

export default MenuItem;
